import { render, staticRenderFns } from "./pack.vue?vue&type=template&id=084f7e40&scoped=true&"
import script from "./pack.vue?vue&type=script&lang=ts&"
export * from "./pack.vue?vue&type=script&lang=ts&"
import style0 from "./pack.vue?vue&type=style&index=0&id=084f7e40&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f7e40",
  null
  
)

export default component.exports